import styled from 'styled-components';

import { ContainedModal } from 'src/components/shared/ContainedModal';
import { DeviceType } from 'src/enums';

export const Container = styled.div`
    display: flex;
    min-height: 4.8rem;
`;

export const LogoReferenceContainer = styled.div`
    display: flex;
    height: 4rem;
    justify-content: space-between;
    margin-bottom: 1rem;
`;

export const Title = styled.span`
    flex: 1;
    font-size: 1.4rem;
    font-weight: 500;
    align-self: center;
`;

export const SignedButton = styled.a<{ signed: boolean }>`
    display: flex;
    gap: 0.4rem;
    cursor: pointer;
    align-self: center;
    height: fit-content;
    font-size: 1.28rem;
    font-weight: 600;
    padding: ${({ signed }) => (signed ? '0.6rem' : '1rem')};
    text-align: center;
    border: 0.1rem solid
        ${({ theme: { colors }, signed }) =>
            signed ? colors.b2cGreen : colors.b2cRedThl};
    color: ${({ theme: { colors }, signed }) =>
        signed ? 'white' : colors.b2cRedThl};
    background-color: ${({ theme: { colors }, signed }) =>
        signed ? colors.b2cGreen : 'initial'};
    border-radius: 0.2rem;
`;

export const StyledContainedModal = styled(ContainedModal)`
    .rc-dialog-header {
        padding-right: 50px;
        border-bottom: solid 1px
            ${({ theme: { colors } }) => colors.b2cLightGrey} !important;
        color: ${({ theme: { colors } }) => colors.black2} !important;
    }

    .rc-dialog-root {
        max-height: calc(100% - 4rem);
        overflow: auto;
    }

    .rc-dialog-wrap {
        max-height: calc(100% - 4rem);
        overflow: auto !important;
    }
`;

export const SignedButtonText = styled.span`
    align-self: center;
`;

export const DashedLine = styled.div`
    border-bottom: 1px dashed ${({ theme: { colors } }) => colors.b2cLightGrey};
    flex: 1;
    align-self: center;
    margin: 0 1rem;
`;

export const DashedLineWithMargin = styled(DashedLine)`
    margin: 1rem 0;
`;

export const SectionButtonContainer = styled.div<{ deviceType: DeviceType }>`
    display: flex;
    gap: ${({ deviceType }) =>
        deviceType === DeviceType.Mobile ? '2rem' : '1rem'};
    flex-direction: ${({ deviceType }) =>
        deviceType === DeviceType.Mobile ? 'row' : 'column'};
    margin: 2rem 0;
    align-items: stretch;
`;

export const AcceptButton = styled.a<{ selected: boolean }>`
    display: flex;
    flex: 1;
    justify-content: center;
    gap: 0.4rem;
    cursor: pointer;
    height: fit-content;
    font-size: 1.28rem;
    font-weight: 600;
    text-align: center;
    border: solid 0.1rem ${({ theme: { colors } }) => colors.b2cGreen};
    color: ${({ theme: { colors }, selected }) =>
        selected ? 'white' : colors.b2cGreen};
    background-color: ${({ theme: { colors }, selected }) =>
        selected ? colors.b2cGreen : 'initial'};
    border-radius: 2rem;
`;

export const DeclineButton = styled(AcceptButton)`
    border: solid 0.1rem ${({ theme: { colors } }) => colors.b2cRed};
    color: ${({ theme: { colors }, selected }) =>
        selected ? 'white' : colors.b2cRed};
    background-color: ${({ theme: { colors }, selected }) =>
        selected ? colors.b2cRed : 'initial'};
`;

export const AcceptButtonText = styled(SignedButtonText)`
    display: flex;
    gap: 0.5rem;
    align-items: center;
    text-align: center;
    font-size: 1.6rem;
    height: 3.5rem;
    align-content: center;
`;

export const EndOfPageContainer = styled.div`
    display: flex;
    margin-bottom: 1rem;
`;

export const EndOfPageText = styled.span`
    color: ${({ theme: { colors } }) => colors.black2};
    font-size: 1.4rem;
`;

export const DocumentContainer = styled.div`
    max-height: 50rem;
    overflow: scroll;
`;

export const AgreeToDocumentButtonContainer = styled.div`
    border-top: solid 0.3rem ${({ theme: { colors } }) => colors.b2cRedThl};
    margin: 0 -1.5rem;
`;

export const AgreeToDocumentButton = styled.a<{ disabled: boolean }>`
    display: flex;
    justify-content: center;
    gap: 0.4rem;
    cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
    align-self: center;
    height: fit-content;
    font-size: 1.28rem;
    font-weight: 600;
    text-align: center;
    color: white;
    background-color: ${({ theme: { colors }, disabled }) =>
        disabled ? colors.tableBorderGray : colors.b2cRedThl};
    border-radius: 2rem;
    margin: 2rem 1.5rem;
`;

export const AgreeToDocumentButtonText = styled(AcceptButtonText)``;

export const ErrorSpan = styled.span`
    font-size: 1.4rem;
    color: ${({ theme: { colors } }) => colors.b2cAlertRed};
`;

export const LogoContainer = styled.div`
    width: 7.4rem;
    align-self: center;
`;

export const Reference = styled.p`
    align-self: center;
    font-size: 1.4rem;
    font-weight: 600;
    margin-right: 0.5rem;
`;
